import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { PageType } from '@sportworld/js-sdk/src/types/servicesTypes/pageTypes'

import { paths } from '@/constants'
import { pageTypes } from '@/constants/common'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'
import { sendPageImpressionToGTAG } from '@/utils/utils'

export const usePageViewAnalytics = (
  page: PageType | null,
  isPopup?: boolean,
) => {
  const { pathname } = useLocation()
  const pageIdFromUrl = pathname.split('/').pop()
  const appConfig = useStore((state) => state.common.appConfig)

  useEffect(() => {
    const pageId = page?.id
    if (!pageId) {
      return
    }

    let needSendPageViewEvent = !!isPopup
    if (!isPopup) {
      const isHomePage = pathname.includes(paths.HOME)
      const isSelectedPage = pathname.includes(paths.SELECTED_PAGE)
      const isSpecialPage = pathname.includes(paths.SPECIAL_HOME)
      const isSportsPage = pathname.includes(paths.SPORTS)
      const isFocusPage = pathname.includes(paths.FOCUS_PAGE)

      const isBasePagePath =
        isSelectedPage ||
        isSpecialPage ||
        isSportsPage ||
        isHomePage ||
        isFocusPage
      if (isBasePagePath) {
        const basePageId =
          (isHomePage && appConfig?.home?.id) ||
          (isSportsPage && appConfig?.sportsPage?.id) ||
          (isSelectedPage && appConfig?.selected?.id) ||
          (isSpecialPage && appConfig?.specialHome?.id) ||
          (isFocusPage && appConfig?.focusPage?.id)
        needSendPageViewEvent = pageId === basePageId
      } else if (pageIdFromUrl) {
        needSendPageViewEvent = pageIdFromUrl === pageId
      }
    }

    if (needSendPageViewEvent) {
      const pathname = `${paths.PAGE}/${pageId}`
      const tabIndex = page?.tabIndex || 0
      let tabTitle = page.tabs?.[tabIndex]?.title
      if (page.pageType === pageTypes.HOME_TAB) {
        tabTitle = page.homeTab?.[tabIndex]?.title
      }

      sendPageViewEvent(pathname)
      sendPageImpressionToGTAG(pathname, tabTitle)
    }
  }, [page?.id, page?.tabIndex, isPopup, pageIdFromUrl])
}
